'use client'

import { Suspense, useEffect, useState } from 'react';
import FooterSection from 'styleguide/sections/Footer';
import { useCookie } from 'react-use';
import { getGlobalContent } from '@/lib/strapi';
import { getCookie } from '~/modules/utils';

const Footer = (props: any	) => {
	const { aboutMenu, shopMenu, helpMenu, envStore } = props;
	const [store] = useCookie('region');
	const [data, setData] = useState(props);

	const updateContentOnRegionChange = async (region: string) => {
		setData({
            ...await getGlobalContent({ preview: region === 'dev' ? 'staging' : '', store: region }),
        })
    }

	useEffect(() => {
		if (store !== null) updateContentOnRegionChange(store);
		else if (store === null) {
			const region = getCookie('region') !== null ? getCookie('region') : envStore;
			updateContentOnRegionChange(region);
		}
    }, []);

	return (
		<>
			<FooterSection
				aboutMenu={data.aboutNav}
				shopMenu={data.shopNav}
				helpMenu={data.helpNav}
				store={store}
			/>
		</>
	);
}

export default Footer;
